import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import LeftNavBar from "./left-navigation/LeftNavBar";
import RightNavBar from "./right-navigation/RightNavBar";
import { MenuProvider } from "./menu/MenuProvider";
import CategoryLinksBar from "./CategoryLinksBar";
import { Divider } from "@mui/material";

const TOP_BANNER_HEIGHT = 32; // px

export const NavBar = () => {
  const [atTop, setAtTop] = useState(true);

  useEffect(() => {
    const onScroll = () => setAtTop(window.scrollY < 50);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <MenuProvider>
      <AppBar
        position="fixed"
        sx={{
          background: "#047ABC",
          boxShadow: "none",
          top: atTop ? `${TOP_BANNER_HEIGHT}px` : "0px",
          zIndex: 1200,
          transition: "top 0.3s ease-in-out",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            minHeight: { xs: 76, md: 80 },
            px: { xs: 1, md: 4 },
          }}
        >
          <LeftNavBar />
          <RightNavBar />
          <Divider sx={{ backgroundColor: "#A1C6DA", height: "0.5px" }} />
        </Toolbar>
        {/* Desktop: Category links bar below main navbar */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <CategoryLinksBar />
        </Box>
      </AppBar>
    </MenuProvider>
  );
};
